import React from 'react';

import { formatNumSeedBags } from 'util/formatters/numberFormatter';
import { getMessage } from 'util/locale';

const BagsNeededRow = ({
  originalNumSeedBags,
  activeNumSeedBags,
  yourPlanNumSeedBags
}: {
  originalNumSeedBags: number;
  activeNumSeedBags: number;
  yourPlanNumSeedBags: number;
}) => (
  <tr>
    <th role='rowheader'>{getMessage('bags-needed')}</th>
    <td>{formatNumSeedBags(yourPlanNumSeedBags)}</td>
    <td>{formatNumSeedBags(originalNumSeedBags)}</td>
    <td>{formatNumSeedBags(activeNumSeedBags)}</td>
  </tr>
);

export default BagsNeededRow;
